import styles from './styles.module.sass';

import cn from 'classnames';
import { useState } from 'react';
// import { closeAgricultureModal } from '@@/agriculture/store/agriculture.store';
import { FillBagModal } from '@@/bags/components/fill-bag-modal';

export function FillBag(props: IFillBagProps) {
  const { id, buttonClassName = '', buttonContent = 'заполнить', editPanel } = props;
  const rootClass = cn(buttonClassName, styles.buttonClassName, styles.fillButton);
  const [modalIsVisible, setModalIsVisible] = useState(false);

  // const [selectedCulture, setSelectedCulture] = useState<number | null>(null);
  // const [inputs, setInputs] = useImmer({ ...FILL_BAG_DEFAULT_INPUTS });

  // const onReset = () => {
  //   setSelectedCulture(null);
  //   setInputs({ ...FILL_BAG_DEFAULT_INPUTS });
  // };
  const onClose = () => {
    //  ();
    // closeAgricultureModal();
    setModalIsVisible(false);
  };

  return (
    <>
      {editPanel && <div className={styles.editPanel}>{editPanel}</div>}
      <button className={rootClass} onClick={() => setModalIsVisible(true)}>
        {buttonContent}
      </button>

      {modalIsVisible && <FillBagModal id={id} onClose={onClose} />}
    </>
  );
}

export interface IFillBagProps {
  id: string;
  buttonClassName?: string;
  buttonContent?: string | React.ReactNode;
  editPanel?: React.ReactNode;
}
